module.exports = __webpack_public_path__ + "img/wifi_off.4bb4ef30.svg";